import React from 'react';
import styles from './StatusBadge.module.css';

export type StatusVariant =
  | 'active' | 'suspended' | 'trial' | 'expired'
  | 'success' | 'warning' | 'error' | 'info'
  | 'starter' | 'pro' | 'enterprise';

interface StatusBadgeProps {
  variant: StatusVariant;
  label?: string;
  dot?: boolean;
  size?: 'sm' | 'md';
}

const LABELS: Record<StatusVariant, string> = {
  active:     'Active',
  suspended:  'Suspended',
  trial:      'Trial',
  expired:    'Expired',
  success:    'Success',
  warning:    'Warning',
  error:      'Error',
  info:       'Info',
  starter:    'Starter',
  pro:        'Pro',
  enterprise: 'Enterprise',
};

const StatusBadge: React.FC<StatusBadgeProps> = ({
  variant,
  label,
  dot = true,
  size = 'md',
}) => (
  <span className={`${styles.badge} ${styles[variant]} ${styles[size]}`}>
    {dot && <span className={styles.dot} />}
    {label ?? LABELS[variant]}
  </span>
);

export default StatusBadge;